import React from 'react'
const bee = require('../assets/LOGO.png')
const text1 = require('../assets/text_01.png')
const text2 = require('../assets/text_02.png')

const LogoPanel = () => {

    return (
        <div className="logo-section">
            <div className="justify-content-center bee-logo">
                <img src={bee} width='30' className="card-img-top padd-5" alt="Vision" />
            </div>
            <div className="justify-content-center text1">
                <img src={text1} width='30' className="card-img-top padd-5" alt="Vision" />
            </div>
            <div className="justify-content-center text2">
                <img src={text2} width='30' className="card-img-top padd-5" alt="Vision" />
            </div>
        </div>
    )
}

export default LogoPanel